import * as React from "react";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";

export default function ColorSlider({value, onSliding}) {
  const color = "primary";
  return (
    <Box sx={{ width: 300 }}>
      <Slider aria-label="Temperature" value={value} onChange={(e)=>{onSliding(e)}} defaultValue={30} color={color} />
    </Box>
  );
}
